import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IonSelect, IonSelectOption } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'lib-language-selector',
  standalone: true,
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, IonSelect, IonSelectOption],
})
export class LanguageSelectorComponent {
  // inputs
  activeLanguage = input<string>();
  availableLanguages = input<Array<string>>();

  // outputs
  selectActiveLanguage = output<string>();

  // methods
  handleSelectLanguage(language: string) {
    this.selectActiveLanguage.emit(language);
  }
}
